/** Web: gallery picker uses browser APIs; Android permission module is absent from RN-web. */
export type GalleryPermission = 'full' | 'limited' | 'denied';

export async function requestAndroidGalleryPermission(): Promise<GalleryPermission> {
  return 'full';
}

export async function ensureAndroidGalleryPermission(): Promise<boolean> {
  return true;
}
